<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-alert type="info" outlined>
          <div class="title">关于</div>
          <div>
            欢迎来到NEGOCES的工具集<br />点击右上角的三条横线打开工具菜单
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  data: () => ({}),
};
</script>
